import React from "react";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";

export default function TenantPickerCard({
  t,
  loadingTenants,
  tenants,
  selectedTenant,
  onSelectTenantId,
  refreshTenants,
}) {
  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={7}>
          <Typography variant="h6">
            {t("SuperAdminTenantsRegLinksPage.title", "Registračné odkazy organizácií")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(
              "SuperAdminTenantsRegLinksPage.subtitle",
              "Vydávanie, prehľad a zneplatnenie registračných odkazov pre gateway."
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={5} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="outlined" onClick={refreshTenants} disabled={loadingTenants}>
            {t("SuperAdminTenantsRegLinksPage.actions.refreshTenants", "Obnoviť organizácie")}
          </Button>
        </Grid>

        <Grid item xs={12} md={8}>
          {loadingTenants ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <CircularProgress size={20} />
              <Typography variant="body2" color="text.secondary">
                {t("SuperAdminTenantsRegLinksPage.loadingTenants", "Načítavam organizácie…")}
              </Typography>
            </Box>
          ) : (
            <Autocomplete
              options={tenants}
              value={selectedTenant || null}
              onChange={(_, value) => onSelectTenantId(value?.id || "")}
              getOptionLabel={(x) => `${x.name} (${x.slug}) — #${x.id}`}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("SuperAdminTenantsRegLinksPage.fields.tenant", "Tenant")}
                />
              )}
            />
          )}
        </Grid>

        {selectedTenant && (
          <Grid item xs={12} md={4}>
            <Typography variant="body2" color="text.secondary">
              {t("SuperAdminTenantsRegLinksPage.selectedTenantLabel", "Vybraná organizácia:")}{" "}
              <strong>
                {selectedTenant.name} ({selectedTenant.slug}) — #{selectedTenant.id}
              </strong>
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}
